import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';

import { WarningType } from '@interfaces/highRiskSupplements';
import { RiskSupplementWarningType } from '@models/riskSupplementWarningType';

import './style.scss';

interface IProps {
  data: RiskSupplementWarningType;
  iconSize?: number;
  textSize?: number;
}

const WarningTypeIcons: { [key: number]: string } = {
  [WarningType.AntiDopping]: '/images/img-science-off.svg',
  [WarningType.Regulatory]: '/images/img-quick-reference.svg',
  [WarningType.AnalyticalFinding]: '/images/img-pill-off.svg',
};

const WarningTypeItem: FC<IProps> = ({ data, iconSize = 16, textSize = 11 }): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Box className="warning-type-item__wrapper">
      <Box className="warning-type-item__icon-wrapper">
        {WarningTypeIcons[data.id] && (
          <Box component="img" width={iconSize} height={iconSize} src={WarningTypeIcons[data.id]} />
        )}
      </Box>
      <Typography
        component="p"
        sx={{
          fontSize: textSize,
        }}
        className="warning-type-item__text"
      >
        {t(data.name)}
      </Typography>
    </Box>
  );
};

export default WarningTypeItem;
